













import Vue from 'vue';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import { mapActions, mapGetters } from 'vuex';
import Instruction  from './Instruction.vue';
import { IInstruction } from '@/requests/mainApi/models/IInstruction';

interface Data {

}

interface Methods {
  getInstructions: () => void
}

interface Computed {
  instructions: IInstruction[],
}

interface Props {}

export default Vue.extend({
  name: 'Instructions',
  components: {
    Instruction
  },
  data() {
    return {

    };
  },
  computed: {
    ...mapGetters(['instructions']),
  },
  methods: {
    ...mapActions(['getInstructions']),
  },
  mounted() {
    this.getInstructions();
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
